import { Routes, Route, Outlet } from "react-router-dom";
import OperationsContextProvider from "../context/OperationsContextProvider";
import CenterOperations from "../pages/CenterOperations";

export default function OperationsRoutes() {
  return (
    <>
      <OperationsContextProvider>
        <Routes>
          <Route
            path="/center"
            element={<CenterOperations />} />
          <Route />
        </Routes>
        <Outlet />
      </OperationsContextProvider>
    </>
  );
}
